import {firestore} from "../../config/firebaseConfig";
import {selectCategoryList} from "../../constant/selectors";
import {isArray, isFunction, orderBy} from "lodash";

const categoryDocRef = firestore.collection('categories').doc('list');

const orderList = list => isArray(list) ? orderBy(list, ['label'], ['asc']) : []

export const createCategory = (category, callback = null) => {
    return async (dispatch, getState) => {
        try {

            const formatted = {...category, children: orderList(category?.children)}

            const categories = selectCategoryList(getState());

            const list = orderList([...categories, formatted])

            await categoryDocRef.set({data: list})

            isFunction(callback) && callback();

        } catch (error) {
            console.error(error)
        }
    }
}

export const editCategory = (category, callback = null) => {
    return async (dispatch, getState) => {
        try {

            const formatted = {...category, children: orderList(category?.children)}

            const categories = selectCategoryList(getState());

            const list = orderList([...categories.map(one => (one.id === formatted.id) ? formatted : one)])

            await categoryDocRef.set({data: list})

            isFunction(callback) && callback();

        } catch (error) {
            console.error(error)
        }
    }
}

export const deleteCategory = (categoryId, callback = null) => {
    return async (dispatch, getState) => {
        try {

            const categories = selectCategoryList(getState());

            const list =  [...categories.filter(one => (one.id !== categoryId))];

            await categoryDocRef.set({data: list})

            isFunction(callback) && callback();

        } catch (error) {
            console.error(error)
        }
    }
}